import { CurrencyCode, CurrencySymbol, CurrencyValues } from './currencies';

interface IPrice {
  summary(): IPriceSummary;
  buildPrice(): {
    toString: () => string;
    toNumber: () => number;
  };
}

interface IPriceSummary {
  priceWithoutTaxes: string;
  taxPercentage: string;
  totalPrice: string;
}

export class Price implements IPrice {
  public amount: number;
  public currency: CurrencyCode;
  public decimals: number;

  constructor(amount: number, currency: CurrencyCode, decimals: number) {
    this.amount = amount;
    this.currency = currency;
    this.decimals = decimals;
  }

  private getCurrencyValue(currency: CurrencyCode): CurrencySymbol {
    return CurrencyValues[currency];
  }

  public buildPrice(): { toString: () => string; toNumber: () => number } {
    let price = this.amount / Math.pow(10, this.decimals);

    return {
      toString: () =>
        `${price.toFixed(2)}${this.getCurrencyValue(this.currency)}`,
      toNumber: () => price,
    };
  }

  summary(): IPriceSummary {
    return {
      priceWithoutTaxes: '',
      taxPercentage: '21%',
      totalPrice: this.buildPrice().toString(),
    };
  }
}
